import { initialProps } from '@utils/initial'
import { routes } from '@group-devs/yfp7-global-modules/data/lcw'

import Error from '../404'
import Head from 'next/head';
import {LcwLayout,LearnHowTo,ConfusingFrustrating,DavidColby,TvcWorkbook} from '@components/Block'

export async function getServerSideProps({req, res, query}) {
    return {
        props: await initialProps(req, res, query, routes.tvc)
    }
}

const tvc = (props) => {
    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    return (
        <div className="page__Tvc">
            <LcwLayout global={props}
            ogurl="/vitamin-checklist" 
            ogsiteName="The Vitamin Checklist"
            ogsiteDesc="Learn the right questions to ask when buying your next vitamin supplement." 
            ogImg="../images/tvc/img-tvc-share01.jpg"
            ogIcon="../images/tvc/img-favicon-tvc02.png"
            >
                <LearnHowTo global={props}/>
                <ConfusingFrustrating global={props}/>
                <DavidColby/>
                <TvcWorkbook global={props}/>
            </LcwLayout>
            <style jsx global>{`
                .bg-orange{
                background:#FC8D58;
                }
                .text-orange{
                color:#FC8D58;
                }
                .btn:hover,
                .btn:focus,
                .btn:active{
                text-decoration: none;
                box-shadow: none;
                }
                @media(max-width: 991px){
                    .text-btn-center{
                        text-align:center!important;
                    }
                }
                @media(max-width: 480px){
                    .btn{
                        padding:0px;
                        font-size:1.5rem;
                    }
                    .media{
                        display:block;
                    }
                    .media img{
                        display: block;
                        margin-left: auto!important;
                        margin-right: auto!important;
                    }
                }
                `}
            </style>
        </div>
    )
}

export default tvc